export function initComment() {
    const commentContainer = document.getElementById('comment-form-root')
    const commentSentForm = document.getElementById('comment-sent')
    if (!commentContainer) return
    const form = commentContainer.querySelector('form')

    const onSubmit = (e) => {
        e.preventDefault()

        fetch('/ajax/sendEmailReview', {
            method: 'post',
            headers: { 'x-requested-with': 'XMLHttpRequest' },
            body: new FormData(form)
        })

        commentContainer.hidden = true
        commentSentForm.hidden = false
        commentSentForm.setAttribute('role', 'status')
    }

    form.addEventListener('submit', onSubmit, { once: true })
}